<ion-header slp-ionic-platform>
  <ion-item lines="none"
    ><ion-label slot="start">My Profile</ion-label>
    <ion-button slot="end" (click)="dismissModal()"> <ion-icon name="close-outline"></ion-icon></ion-button>
  </ion-item>
</ion-header>
<ion-content gaCategory="user_profile" slp-ionic-platform>
  <ion-item lines="none"><ion-label class="title">User information</ion-label></ion-item>

  <form [formGroup]="userForm" *ngIf="showForm">
    <ion-row>
      <ion-col>
          <ion-row>
            <ion-item lines="none" *ngIf="platform.isDesktop()">
              <ion-label class="input-label">{{ "administration.userDetails.firstName" | translate }}</ion-label>
            </ion-item>
          </ion-row>
          <ion-row>
            <ion-item class="textfield" [lines]="platform.isDesktop() ? 'full' : 'none'">
              <ion-label position="floating" *ngIf="!platform.isDesktop()">{{
                "administration.userDetails.firstName" | translate
              }}</ion-label>
              <ion-input id="firstNameInput" type="text" formControlName="firstName"></ion-input>
            </ion-item>
            <validation-messages [control]="userForm.controls.firstName"></validation-messages>
          </ion-row>
      </ion-col>
      <ion-col>
        <ion-row>
          <ion-item lines="none" *ngIf="platform.isDesktop()">
            <ion-label class="input-label">{{ "administration.userDetails.lastName" | translate }}</ion-label>
          </ion-item>
        </ion-row>
        <ion-row class="names">
          <ion-item class="textfield names" [lines]="platform.isDesktop() ? 'full' : 'none'">
            <ion-label position="floating" *ngIf="!platform.isDesktop()">{{
              "administration.userDetails.lastName" | translate
            }}</ion-label>
            <ion-input id="lastNameInput" type="text" formControlName="lastName"></ion-input>
          </ion-item>
          <validation-messages [control]="userForm.controls.lastName"></validation-messages>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-item lines="none" *ngIf="platform.isDesktop()">
      <ion-label class="input-label email">{{ "administration.userDetails.email" | translate }}</ion-label>
      <ion-icon *ngIf="domains && domains.length > 0" name="information-circle" (click)="openDomains($event)"></ion-icon>
    </ion-item>
    <ion-item class="textfield" [lines]="platform.isDesktop() ? 'full' : 'none'">
      <ion-label position="floating" *ngIf="!platform.isDesktop()">{{ "administration.userDetails.email" | translate }}</ion-label>
      <ion-input id="emailInput" type="text" formControlName="email"></ion-input>
    </ion-item>
    <validation-messages [control]="userForm.controls.email"></validation-messages>
    <ion-item lines="none" *ngIf="platform.isDesktop()">
      <ion-label class="input-label">{{ "administration.userDetails.phoneNumber" | translate }}</ion-label>
    </ion-item>
    <ion-item class="textfield" [lines]="platform.isDesktop() ? 'full' : 'none'">
      <ion-label position="floating" *ngIf="!platform.isDesktop()">{{
        "administration.userDetails.phoneNumber" | translate
      }}</ion-label>
      <ion-input id="phoneInput" appPhoneMask type="text" formControlName="phoneNumber" maxLength="14"></ion-input>
    </ion-item>
    <validation-messages [control]="userForm.controls.phoneNumber"></validation-messages>
  </form>
  <ion-item #successMessage lines="none" [hidden]="true">
    <ion-label class="successMessage">{{ "administration.userDetails.saveSuccessfullMessage" | translate }}</ion-label>
  </ion-item>
</ion-content>
<ion-footer>
  <ion-item lines="none">
    <ion-button gaEvent="update_profile" type="submit" [disabled]="this.userForm.pristine || this.userForm.invalid" (click)="submit()">Save</ion-button>
  </ion-item>
</ion-footer>
<ion-popover #popoverDom reference="event">
  <ng-template>
    <ion-list>
      <ion-item lines="none" *ngFor="let item of domains">
        <ion-label>{{item}}</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>